import angular from "angular";
import Home from "./home/home";
import About from "./about/about";
import Accounttype from "./accounttype/accounttype";
import Signin from "./signin/signin";
import Signon from "./signon/signon";
import Signup from "../scenes/signup/signup";
import PostAShiftWalkThrough from "../scenes/postashiftwalkthrough/postashiftwalkthrough";
import References from "../scenes/references/references";
import Events from "./events/events";
import RecoveryPassword from "./recoverpassword/recoverpassword";
import RecoveryPasswordSuccess from "./recoverpasswordsuccess/recoverpasswordsuccess";
import Onboarding1 from "./onboarding1/onboarding1";
import Onboarding2 from "./onboarding2/onboarding2";
import Onboarding3 from "./onboarding3/onboarding3";
import EventOverview from "./eventoverview/eventoverview";
import Inbox from "./inbox/inbox";
import Billing from "./billing/billing";
import Transactionhistory from "./transactionhistory/transactionhistory";
import EventEditDetails from "./eventeditdetails/eventeditdetails";
import EventReviewApplicants from "./eventreviewapplicants/eventreviewapplicants";
import RejectedApplicants from "./eventreviewapplicants/rejectedapplicants/rejectedapplicants";
import Messaging from "./messaging/messaging";
import EventRoster from "./eventroster/eventroster";
import Jobsdashboard from "./jobsdashboard/jobsdashboard";
import EventLive from "./eventlive/eventlive";
import EventComplete from "./eventcomplete/eventcomplete";
import EventsHistory from "./eventshistory/eventshistory";
import Invoice from "./invoice/invoice";
import Jobbler from "./jobbler/jobbler";

import Ordersmasterlist from "./orders/ordersmasterlist/ordersmasterlist";
import Basicprofile from "./jobbler/basicprofile/basicprofile";
import Preferences from "./jobbler/preferences/preferences";
import Banking from "./jobbler/banking/banking";
import Teams from "./teams/teams";
import Teamdetails from "./teamdetails/teamdetails";
import Connections from "./connections/connections";
import Uber from "./deals/uber/uber";
import Ubercampaigns from "./campaigns/ubercampaign/ubercampaign";
import Profiles from "./profiles/profiles";
import Jobs from "./jobs/jobs";

import PostEvent from "./postevent/postevent";
import Postjobbulk from "./postevent/postjobbulk/postjobbulk";
import PostOrder from "./postorder/postorder";
import Posttypes from "./accountprofile/posttypes/posttypes";
import Charges from "./accountprofile/charges/charges";
import Transfers from "./accountprofile/transfers/transfers";

import AccountProfile from "./accountprofile/accountprofile";
import DirectPay from "./directpay/directpay";
import Payshifts from "./payshifts/payshifts";
import AdminDash from "./admindash/admindash";
import AdminTransactions from "./admintransactions/admintransactions";
import AdminEvents from "./adminevents/adminevents";
import AdminApplicants from "./adminapplicants/adminapplicants";
import AdminOpenings from "./adminopenings/adminopenings";
import AdminHires from "./adminhires/adminhires";
import AdminWithdrawals from "./adminwithdrawals/adminwithdrawals";
import Jobdetails from "./jobdetails/jobdetails";

let componentModule = angular.module("app.components", [
  Home.name,
  About.name,
  Accounttype.name,
  Signin.name,
  Invoice.name,
  Signup.name,
  Signon.name,
  Jobsdashboard.name,
  PostAShiftWalkThrough.name,
  References.name,
  Payshifts.name,
  RecoveryPassword.name,
  RejectedApplicants.name,
  Basicprofile.name,
  Preferences.name,
  Postjobbulk.name,
  Billing.name,
  Banking.name,
  Posttypes.name,
  Charges.name,
  Transfers.name,
  RecoveryPasswordSuccess.name,
  Events.name,
  Onboarding1.name,
  Uber.name,
  Ubercampaigns.name,
  Jobbler.name,
  Onboarding2.name,
  Jobs.name,
  Teamdetails.name,
  Onboarding3.name,
  Ordersmasterlist.name,
  EventOverview.name,
  Inbox.name,
  Transactionhistory.name,
  EventEditDetails.name,
  EventReviewApplicants.name,
  Messaging.name,
  EventRoster.name,
  EventLive.name,
  EventComplete.name,
  Jobdetails.name,
  EventsHistory.name,
  Teams.name,
  Connections.name,
  Profiles.name,
  PostEvent.name,
  PostOrder.name,
  AccountProfile.name,
  DirectPay.name,
  AdminDash.name,
  AdminTransactions.name,
  AdminEvents.name,
  AdminApplicants.name,
  AdminOpenings.name,
  AdminHires.name,
  AdminWithdrawals.name,
]);

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js